import React from 'react'
import { Link } from '@reach/router'
import pdf from './images/Eloisa-Mae-Salvacion-Product-Designer-CV.pdf'
import { LazyLoad } from './Functions'

// const NavLink = props => (
//   <Link
//     {...props}
//     getProps={({ isPartiallyCurrent } = props) => {
//       return {
//         className: `block mt-4 lg:inline-block lg:mt-0 text-black hover:text-gray-600 mr-12 font-bold disabled:opacity-50 text-sm ${isPartiallyCurrent ? "active" : ""}`
//       };
//     }}
//     disabled="true"
//   />
// )

function Nav() {
  return (
    <header className="bg-white text-gray-100 body-font shadow w-full fixed top-0 animated z-40">
      <div className="container mx-auto flex flex-wrap py-5 flex-col md:flex-row items-center justify-between">
        <Link to="/" className="lg:w-4/12 inline-flex lg:justify-start">
          <LazyLoad src={require('./images/loisy_logo.svg')} className="loisy_logo" alt="logo" />
        </Link>
        <div className="lg:w-8/12 inline-flex lg:justify-end ml-5 lg:ml-0">
          <nav className="flex flex-row items-center text-base">
            <a href="mailto:eloisamaesalvacion@gmail.com" className="text-black font-bold mr-10">eloisamaesalvacion@gmail.com</a>
            <a href={pdf} className="bg-yellow-400 hover:bg-yellow-500 text-black font-bold py-2 px-4 border-b-4 border-yellow-700 hover:border-yellow-600 rounded text-sm" download>
              DOWNLOAD CV
            </a>
          </nav>
        </div>
      </div>
    </header>
  )
}

export default Nav
